import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import ActionMenu from 'components/ActionMenu';
import ContactsContext from '../../../../providers/Contacts/Contacts.context';
import { useTranslation } from 'react-i18next';
import TrashIcon from 'icons/Trash.icon';
import AddProfile from 'icons/AddProfile.icon';

import './ContactsActionMenu.styles.scss';
import './ContactsActionMenu.styles.responsive.scss';

type ContactsActionMenuProps = {
  className?: string;
};

const ContactsActionMenu: React.FC<ContactsActionMenuProps> = (props) => {
  const { className } = props;

  const { selected, isDeleting, removeAll, handleDelete, handleManage } =
    useContext(ContactsContext);

  const { t } = useTranslation();

  const classes = classNames('contacts-action-menu', className);

  const actions = useMemo(
    () => [
      {
        icon: AddProfile,
        className: 'add-profile',
        onClick: () => handleManage(selected),
      },
      {
        alert: true,
        disabled: isDeleting,
        icon: TrashIcon,
        onClick: () => handleDelete(selected),
      },
    ],
    [handleDelete, handleManage, isDeleting, selected],
  );

  if (!selected.length) return null;

  return (
    <ActionMenu
      className={classes}
      label={t('contactsSelected', { count: selected.length })}
      actions={actions}
      onClose={removeAll}
    />
  );
};

export default ContactsActionMenu;
